import { render, staticRenderFns } from "./BasicDialog.vue?vue&type=template&id=18904dda&"
import script from "./BasicDialog.vue?vue&type=script&lang=ts&"
export * from "./BasicDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BasicDialog.vue?vue&type=style&index=0&id=18904dda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports